// const moment = require('moment');
import moment from 'moment-timezone';

export function FORMAT_TEXT(text) {
  const text_ = text?.length > 20 ? text?.substring(0, 20) + '...' : text
  return text_
}

export function FORMAT_TEXT_VALUE(text) {
  const text_  = text.replace(/_/g, ' ').toLowerCase().replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
  return text_
}
export function FORMAT_TIME_VALUE(timeString) {
  return moment(timeString, 'HH:mm:ss').format('hh:mm A');

}
export function isBase64(str) {
  try {
    return btoa(atob(str)) === str;
  } catch (err) {
    return false;
  }
}

export function DATE_FORMAT(inputDate) {
  const formattedDate = moment(inputDate).format('MMM D, YYYY');
  return formattedDate;
}
 
export function DATE_FORMAT_TIME(inputDate) {
  const formattedDate = moment(inputDate).format('MMM D, YYYY hh:mm A');
  return formattedDate;
}

export function DATE_FORMAT_TIME_(inputDate) {
  const formattedDate = moment(inputDate).format('YYYY-MM-DD hh:mm:ss');
  return formattedDate;
}

export function validateNullEmptyValue(sanitizedCaregiverDetails) {
  //null param not send
    Object.keys(sanitizedCaregiverDetails).forEach((key) => {
      if (
        sanitizedCaregiverDetails[key] === null ||
        sanitizedCaregiverDetails[key] === "" ||
        sanitizedCaregiverDetails[key] === "Invalid date" ||
        sanitizedCaregiverDetails[key] === "null"
      ) {
        delete sanitizedCaregiverDetails[key];
      }
    });
    return sanitizedCaregiverDetails
}

export function validateEditEmptyValues(query) {
  //null param not send
    if(query.player_classification !== 'junior'){
      delete query.academy_name    
      delete query.hight_school
      // delete query.graduation_year
      delete query.universities_attend
    }
    if(query.player_classification !== 'college'){
      delete query.college    
      // delete query.graduation_year
      delete query.major
    }
    if(query.player_classification !== 'professional'){
      delete query.training_facility    
    }
     if(query.player_classification !== 'professional'){
      delete query.training_facility    
    }
     if(query.player_classification !== 'adult_competitive'){
      delete query.tournaments    
      delete query.profession    
    }
    if(query.player_classification !== 'adult_social'){
      delete query.leagues_play    
      delete query.self_ranking    
      delete query.profession    
    }
    if(query.platform_joining_type !== '2'){
      delete query.parent_name    
      delete query.parent_last_name
      delete query.relationship
      delete query.children_details
    }
    delete query.user_detail;
    delete query.players_parent_info;
    delete query.avoid_players;
    delete query.weeks_preferences;

    return query
}

export function export_csv_fields_data(data) {
  let newArr = []
  for(let val of data){
    const newData = {};
    for (const key in val) {
      const excludedKeys = ['id', 'password', 'social_id', 'social_type', 'otp', 'is_otp_verified', 'is_phone_verified', 'is_notification', 'customer_stripe_id', 'wallet_balance', 'is_profile_completed', 'firebase_token', 'reset_token', 'login_time', 'filter_date', 'user_detail', 'status', 'weeks_preferences', 'image_thumb', 'updated_at'];
      if (!excludedKeys.includes(key)) {
      // Rename specific keys and capitalize all keys
        let newKey =  key.replace(/_/g, ' ').toLowerCase().replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
        if (newKey === "Role") {
            newData[newKey] = val[key] === '1' ? 'User' : '';
        } else if (newKey === "Gender") {
            newData[newKey] = val[key] === '1' ? 'Male' : val[key] === '2' ? 'Female' : val[key] === '3' ? 'Other' : '';
        } else if (newKey === "Opponent Gender") {
          newData[newKey] = val[key] === '1' ? 'Male' : val[key] === '2' ? 'Female' : val[key] === '3' ? 'Other' : '';
        } else if (newKey === "Platform Joining Type") {
          newData[newKey] = val[key] === '1' ? 'Player' : val[key] === '2' ? 'Parent' : '';
        } 
        else if (newKey === "Height") {
          newData[newKey] = `${val[key]} inch`
        } 
        else if (newKey === "Weight") {
          newData[newKey] = `${val[key]} kg`
        } 
        else if (newKey === "Created At") {
          newData[newKey] = DATE_FORMAT_TIME(val[key])
        } 
        else {
            newData[newKey] = val[key];
        }
      }
    }
    newArr.push(newData)
  }
  return newArr;
}
